/* 
eslint-disable no-mixed-operators
*/
import React from 'react';
import DynamicScreen from './';
import { checkCondition } from '../../../../util/conditional';
import { inResults } from '../../../../service';

const DynamicIfScreen = React.memo(
	({descriptor, onRequestScreen, ...props}) => {
		const {condition, screen} = descriptor;
		const conditionResult = checkCondition(condition, (path) => inResults(props.previousScreenResults, path));
		const useScreen = conditionResult && screen;
		React.useEffect(() => {
			if(!useScreen && onRequestScreen)onRequestScreen('next');
		},[useScreen, onRequestScreen]);

		if(useScreen) {
			return (
				<DynamicScreen 
					{...props} 
					onRequestScreen={onRequestScreen}
					descriptor={useScreen} 
					/>
			)
		}
		return null;
	}
);

export default DynamicIfScreen;